import(/* webpackMode: "eager" */ "/app/app/politique-de-confidentialite/page.tsx");
